import React, { useState, useEffect } from 'react';
import '../../../scss/components/pages/staffList.scss';
import swal from 'sweetalert2';
import { monthNames } from '../../../const/constant';

import API from '../../../middleware/API';
import moment from 'moment';
import axios from 'axios';
import { lowerCase } from 'lodash';
import Slider from 'react-slick';
import Pagination from '../../Pagination';
import {useDispatch} from 'react-redux';
import ReviewLeave from '../../ReviewLeave'

const LeaveExpireNotice = () => {
  const [leaveRecList, setLeaveRecList] = useState ([]);
  const [reload, doReload] = useState (false);
  const [currPage, setCurrPage] = useState (1);
  const [totalPage, setTotalPage] = useState (0);
  const [countOfPage, setCountOfPage] = useState (10);
  const dispatch = useDispatch()

  useEffect(
    ()=>{
      axios.all([
        API.get(`/LeaveRec/NearExpireAnnualLeave`),
      ]).then(
        axios.spread((res) => {
          console.log(res);
          setLeaveRecList(res.sort((a, b) => {
            if (a.eDate === "0001-01-01T00:00:00") return 1;
            if (b.eDate === "0001-01-01T00:00:00") return -1;
            return new Date(a.eDate) - new Date(b.eDate);
        }).slice((currPage - 1) * countOfPage, ((currPage - 1) * countOfPage) + countOfPage))
          setTotalPage(Math.ceil(res.length / 10))
        })
      );    
    }
  ,[reload]);

  const handleChangePage = (page) => {
    setCurrPage(page);
    doReload(!reload);
  }


  const settings = {
    dots: true,
    arrows: false,
  };

  const slides = leaveRecList.map((leaveRec, index) => (
    <div key={leaveRec.id}>
    <table className="u-table u-table-border u-table-striped u-table-media-phone">
      <tbody>
          <tr>
          <th>Id</th>
          <td>{leaveRec.userId}</td>
        </tr>
        <tr>
          <th>姓名</th>
          <td>{leaveRec.userName}</td>
        </tr>
        <tr>
          <th>剩餘時數</th>
          <td>{(leaveRec.leavesDay * 8) - leaveRec.takeOffHours}</td>
        </tr>
        <tr>
          <th>到期日</th>
          <td>{leaveRec.eDate.split('T')[0]}</td>
        </tr>
      </tbody>
    </table>
  </div>
  ))

  console.log(monthNames)
 return(
  <div className="p-signTime">
  <div className="u-block u-block--fixHeight">
      <div className="u-title">2025特休即將到期員工列表
        
      </div>
      <div className="u-notice">※此處顯示數值非即時資訊，僅為每月初紀錄之歷史資料。</div>
      <div className="u-notice">※即時資訊請至員工列表查看。</div>

      <div className="u-table-responsive">    
      <table className="u-table u-table-border u-table-striped u-table-media">
          <thead>
            <tr>
            <th rowSpan={2}>ID</th>               

            <th rowSpan={2}>姓名</th>               
            <th colSpan={12}>剩餘補休時數</th>               
            <th colSpan={12}>剩餘特休時數</th>               
            <th rowSpan={2}>特休到期日</th>               
            </tr>
            <tr>
            {
                    monthNames.map((monthName, index) => {
                      const monthValue = index < 9 ? `0${index + 1}` : index + 1;
                      return (
                        <th key={monthValue} value={monthValue}>{monthName}</th>
                      );
                    })
                  }
                              {
                    monthNames.map((monthName, index) => {
                      const monthValue = index < 9 ? `0${index + 1}` : index + 1;
                      return (
                        <th key={monthValue} value={monthValue}>{monthName}</th>
                      );
                    })
                  }
            </tr>
          </thead>
            {
              leaveRecList.map(leaveRec => (
                <tbody key={leaveRec.userId}>
                    <tr key={leaveRec.userId} style={{backgroundColor:leaveRec.isNear && leaveRec.eDate.split('T')[0] !== '0001-01-01'?'yellow':''}}>
                    <td>{leaveRec.userId}</td>
                    <td>
  {leaveRec.userName}
  <button
    className="btn btn-sm edit m-l-8"
    onClick={() => {
      // 呼叫 API 獲取補休時數變更記錄
      API.get(`/User/CompensatoryHoursLog/${leaveRec.userId}`)
        .then((response) => {
          if (response && response.length > 0) {
            // 分頁顯示記錄
            const recordsPerPage = 10;
            let currentPage = 1;

const renderTable = (page) => {
  const recordsPerPage = 10; // 每頁顯示的記錄數量
  const startIndex = (page - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  const paginatedRecords = response.slice(startIndex, endIndex);

  const tableHtml = `
    <div style="max-height: 400px; max-width: 100%; overflow-x: auto; overflow-y: auto;">
      <table class="u-table u-table-border u-table-striped" style="width: 100%; table-layout: auto;">
        <thead>
          <tr>
            <th style="white-space: nowrap;">變更前時數</th>
            <th style="white-space: nowrap;">變更後時數</th>
            <th style="white-space: nowrap;">備註</th>
            <th style="white-space: nowrap;">操作人</th>
            <th style="white-space: nowrap;">操作時間</th>
          </tr>
        </thead>
        <tbody>
          ${paginatedRecords
            .map(
              (record) => `
            <tr>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${record.beforeHours}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${record.afterHours}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${record.notes}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${record.createdUserName}</td>
              <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${record.createdDate.replace('T', ' ').slice(0, 19)}</td>
            </tr>
          `
            )
            .join('')}
        </tbody>
      </table>
    </div>
    <div style="display: flex; justify-content: space-between; margin-top: 10px;">
      <button id="prevPage" style="padding: 5px 10px;" ${page === 1 ? 'disabled' : ''}>上一頁</button>
      <span>第 ${page} 頁</span>
      <button id="nextPage" style="padding: 5px 10px;" ${
        endIndex >= response.length ? 'disabled' : ''
      }>下一頁</button>
    </div>
  `;

swal.fire({
  title: `補休時數變更記錄`,
  html: tableHtml,
  onOpen: () => {
    // 綁定上一頁按鈕事件
    const prevPageButton = document.getElementById('prevPage');
    if (prevPageButton) {
      prevPageButton.addEventListener('click', () => {
        if (page > 1) {
          renderTable(page - 1);
        }
      });
    }

    // 綁定下一頁按鈕事件
    const nextPageButton = document.getElementById('nextPage');
    if (nextPageButton) {
      nextPageButton.addEventListener('click', () => {
        if (endIndex < response.length) {
          renderTable(page + 1);
        }
      });
    }
  },
});
};

// 初始顯示第一頁
//renderTable(1);
            // 初始顯示第一頁
            renderTable(currentPage);
          } else {
            swal.fire({
              title: '無記錄',
              text: '該員工沒有補休時數變更記錄。',
              icon: 'info',
            });
          }
        })
        .catch((error) => {
          console.error('獲取補休時數變更記錄失敗:', error);
          swal.fire({
            title: '錯誤',
            text: '無法獲取補休時數變更記錄，請稍後再試。',
            icon: 'error',
          });
        });
    }}
  >
    查看記錄
  </button>
</td>
                    {
                      Array.from({ length: 12 }, (_, i) => i + 1).map(month => {
                        const record = leaveRec.remainHistoryList.find(t => t.month == month);
                        const compensatoryHours = record ? record.compensatoryHours : 0;
                        return <td>{compensatoryHours || 0}</td>;
                      })
                    }
                                        {
                      Array.from({ length: 12 }, (_, i) => i + 1).map(month => {
                        const record = leaveRec.remainHistoryList.find(t => t.month == month);
                        const annualLeaveHours = record ? record.annualLeaveHours : 0;
                        return <td>{(annualLeaveHours) || 0}</td>;
                      })
                    }
                    {/* <td>{leaveRec.compensatoryHours || 0}</td>
                    <td>{(leaveRec.leavesDay * 8) - leaveRec.takeOffHours + leaveRec.carriedForwardHours}</td> */}
                    <td>{leaveRec.eDate.split('T')[0]!== '0001-01-01'? leaveRec.eDate.split('T')[0]:'無特休'}</td>
                    </tr>
                </tbody>

                )
              )
            }
        </table>
      </div>
      {
        leaveRecList.length > 0 ? <Slider {...settings}>
        {
          slides
        }
      </Slider>:''
      }
      <div className="pagination-box">
        <Pagination 
            currPage={currPage} totalPage={totalPage}
            onChangPage={handleChangePage}
        />
      </div>
    </div>
  </div>
 );
}

export default LeaveExpireNotice

